export default __webpack_public_path__ + "static/media/logo-inbursa.9c6279d5.png";